import {
  SET_ALL_BOARDS_NOTES,
  ADD_BOARD_NOTE,
  DELETE_BOARD_NOTE,
  UPDATE_BOARD_NOTE,
} from "../types";
import { setExpiry } from "../../common";

const initialState = {
  allBoardNotes: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_ALL_BOARDS_NOTES: {
      const boardId = payload.boardId;
      setExpiry("sustainchange_all_boards_notes_expiry");
      setExpiry(`sustainchange_single_board_note_expiry_${boardId}`);

      return {
        ...state,
        allBoardNotes: {
          [boardId]: payload.notes,
        },
      };
    }
    case ADD_BOARD_NOTE: {
      const newNote = payload.notes;
      const boardId = payload.boardId;
      const data = {
        ...state,
        allBoardNotes: {
          ...state.allBoardNotes,
          [boardId]: [newNote, ...state?.allBoardNotes[boardId]],
        },
      };
      return data;
    }
    case DELETE_BOARD_NOTE: {
      const noteId = payload.noteId;
      const boardId = payload.boardId;
      let allSingleBoardNotes = state.allBoardNotes[boardId];
      allSingleBoardNotes = allSingleBoardNotes.filter((note) => {
        return note.note_id !== noteId;
      });

      const newState = {
        ...state,
        allBoardNotes: {
          ...state.allBoardNotes,
          [boardId]: allSingleBoardNotes,
        },
      };
      return newState;
    }

    case UPDATE_BOARD_NOTE: {
      const noteId = payload.noteId;
      const boardId = payload.boardId;
      const newNote = payload.notes;

      let allSingleBoardNotes = state.allBoardNotes[boardId];

      allSingleBoardNotes = allSingleBoardNotes.map((note) => {
        if (note?.note_id === noteId) {
          return newNote;
        }
        return note;
      });

      const newState = {
        ...state,
        allBoardNotes: {
          ...state.allBoardNotes,
          [boardId]: allSingleBoardNotes,
        },
      };
      return newState;
    }

    default:
      return state;
  }
}
